var path = 'views/value/string_ajax_autocomplete.html';
var html = "<div class=form-group> <label for=fieldValue>Wert</label> <input type=text class=form-control id=fieldValue ng-model=models.elementCopy.value> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;